interface DiretoriaResultCardProps {
  posicao: number;
  nome: string;
  emoji: string | null;
  descricao: string;
  pontos: number;
  percentual: number;
  destaque?: boolean;
}

const MEDALHAS = ['🥇', '🥈', '🥉'];

export function DiretoriaResultCard({
  posicao,
  nome,
  emoji,
  descricao,
  pontos,
  percentual,
  destaque = false,
}: DiretoriaResultCardProps) {
  return (
    <div
      className={`rounded-lg border p-4 sm:p-5 ${
        destaque ? 'border-primary-300 bg-primary-50' : 'border-gray-200 bg-white'
      }`}
    >
      <div className="flex items-start gap-3">
        <span className="text-2xl sm:text-3xl" aria-hidden="true">
          {emoji ?? MEDALHAS[posicao - 1] ?? '•'}
        </span>

        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1">
            <h3
              className={`font-semibold ${
                destaque ? 'text-lg text-primary-900 sm:text-xl' : 'text-base text-gray-900'
              }`}
            >
              <span className="mr-1 text-gray-400">{posicao}º</span>
              {nome}
            </h3>

            <span className="text-sm font-medium text-gray-600">
              {pontos} {pontos === 1 ? 'ponto' : 'pontos'} · {percentual}%
            </span>
          </div>

          <p className="mt-1 text-sm text-gray-600">{descricao}</p>

          <div className="mt-3 h-1.5 w-full overflow-hidden rounded-full bg-gray-200">
            <div
              className={`h-full rounded-full ${destaque ? 'bg-primary-600' : 'bg-gray-400'}`}
              style={{ width: `${Math.max(percentual, 2)}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
